import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

const normalizeRows = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.rows)) {
    return payload.rows;
  }

  return [];
};

export const getLandedDashboardDetailsSummaryData = async (itemType) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedDashboardDetailsSummaryData}${encodeURIComponent(itemType)}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);
    if (response?.ok) {
      const payload = await response.json().catch(() => []);
      return normalizeRows(payload);
    }

    const errorData = response?.json ? await response.json().catch(() => ({})) : {};
    throw new Error(errorData?.message || "Unable to load dashboard details.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to load dashboard details.", {
      contactSupport: false,
    });
    return [];
  }
};

export default getLandedDashboardDetailsSummaryData;
